export default __webpack_public_path__ + "static/land_commercial-bafa610870ee451b38bf4ac2f24d92f8.png";